// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1MO1I","label":"Labeled_label__LDPsy","divider":"Labeled_divider__t3Ae9"};